import { gsap } from "gsap";

function add_class (className,className2) {

  const body = document.getElementsByTagName('body')[0];

  if (!body.classList.contains(className)) {

    body.classList.remove(className2)
    body.classList.add(className)

  } else {

    body.classList.remove(className)
    body.classList.add(className2)

  }

}
window.add_class = add_class

let toggleButton = document.querySelectorAll('.adminmenu .has-submenu');
for (let i = 0; i < toggleButton.length; i++) {
  toggleButton[i].addEventListener('click',function(){
    let target = this.nextElementSibling;
    // const result = target.classList.contains('open');

    if(this.classList.contains('active')) {
      for (let i = 0; i < toggleButton.length; i++) {
        toggleButton[i].classList.remove('active');
        gsap.to(toggleButton[i].nextElementSibling,{
          height: 0,
          duration:0.25,
          ease: "power2.inOut"
        });
      }
    } else {
      for (let i = 0; i < toggleButton.length; i++) {
        toggleButton[i].classList.remove('active');
        gsap.to(toggleButton[i].nextElementSibling,{
          height: 0,
          duration:0.25,
          ease: "power2.inOut"
        });
      }
      // 開く
      this.classList.add('active');
      gsap.to(target,{
        height:'auto',
        duration:0.25,
        ease: "power2.inOut"
      });
    }
  })
}

let toggleTrigger = document.querySelectorAll('.js-toggleTrigger');
for (let i = 0; i < toggleTrigger.length; i++) {
  toggleTrigger[i].nextElementSibling.classList.add('js-toggleTarget');
  toggleTrigger[i].addEventListener('click',function(){
    if(this.classList.contains('is-open')) {
      this.classList.remove('is-open');
    } else {
      toggleTrigger[i].classList.remove('is-open');
      this.classList.add('is-open');
    }
  });
}
let toggleTriggerSP = document.querySelectorAll('.js-toggleTriggerSP');
for (let i = 0; i < toggleTriggerSP.length; i++) {
  toggleTriggerSP[i].nextElementSibling.classList.add('js-toggleTargetSP');
  toggleTriggerSP[i].addEventListener('click',function(){
    if(this.classList.contains('is-open')) {
      this.classList.remove('is-open');
    } else {
      toggleTriggerSP[i].classList.remove('is-open');
      this.classList.add('is-open');
    }
  });
}
